import React, { useEffect, useState } from "react";
import { Button, Form, Modal, Spinner } from "react-bootstrap";
import axios from "axios";
import { API_URL } from "../../utils/apiRoutes";
import { commonService } from "../../utils/commonService";
import { errorToastMessage, successToastMessage } from "../../utils/toastMessage";

function getListData(data) {
    return data?.DataList1 || data?.dataList1 || [];
}

function SupportTicketCreateModal({ show, onHide, onCreated }) {
    const userDetail = commonService.getLoginUserData();
    const [categories, setCategories] = useState([]);
    const [formData, setFormData] = useState({
        title: "",
        category_termid: "",
        detail: "",
    });
    const [files, setFiles] = useState([]);
    const [submitting, setSubmitting] = useState(false);

    const loadCategories = async () => {
        try {
            const response = await axios.post(
                API_URL.BASE_API_URL.ADMINAPI + API_URL.PUBLIC_SUPPORT_TICKET.TICKET_CATEGORIES,
                {}
            );

            if (response?.data?.status_code === 1) {
                setCategories(getListData(response?.data?.data));
            } else {
                errorToastMessage(response?.data?.message || "Unable to load ticket categories.");
                setCategories([]);
            }
        } catch (error) {
            errorToastMessage(error?.response?.data?.message || error?.message || "Unable to load ticket categories.");
            setCategories([]);
        }
    };

    useEffect(() => {
        if (show) {
            loadCategories();
        }
    }, [show]);

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!formData.title.trim()) {
            errorToastMessage("Please enter a ticket title.");
            return;
        }

        if (!formData.detail.trim()) {
            errorToastMessage("Please enter ticket details.");
            return;
        }

        setSubmitting(true);
        try {
            const payload = new FormData();
            if (Number(userDetail?.clientid || 0) > 0) {
                payload.append("clientid", userDetail?.clientid);
            }
            if (Number(userDetail?.userid || 0) > 0) {
                payload.append("userid", userDetail?.userid);
            }
            payload.append("title", formData.title.trim());
            payload.append("detail", formData.detail.trim());
            if (formData.category_termid) {
                payload.append("category_termid", formData.category_termid);
            }

            files.forEach((file) => {
                payload.append("files", file);
            });

            const response = await axios({
                method: "POST",
                url: API_URL.BASE_API_URL.ADMINAPI + API_URL.PUBLIC_SUPPORT_TICKET.CREATE_TICKET,
                data: payload,
            });

            if (response?.data?.status_code === 1) {
                successToastMessage(response?.data?.message);
                onCreated?.(response?.data?.data);
                setFormData({ title: "", category_termid: "", detail: "" });
                setFiles([]);
                onHide();
            } else {
                errorToastMessage(response?.data?.message || "Unable to create ticket.");
            }
        } catch (error) {
            errorToastMessage(error?.response?.data?.message || error?.message || "Unable to create ticket.");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered size="lg" backdrop="static">
            <Form onSubmit={handleSubmit}>
                <Modal.Header closeButton>
                    <Modal.Title>Create Support Ticket</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-3">
                        <Form.Label>Category</Form.Label>
                        <Form.Select
                            value={formData.category_termid}
                            onChange={(event) =>
                                setFormData((prev) => ({ ...prev, category_termid: event.target.value }))
                            }
                        >
                            <option value="">Select category</option>
                            {categories?.map((item) => (
                                <option key={item?.termid} value={item?.termid}>
                                    {item?.term}
                                </option>
                            ))}
                        </Form.Select>
                    </div>
                    <div className="mb-3">
                        <Form.Label>Title</Form.Label>
                        <Form.Control
                            type="text"
                            value={formData.title}
                            onChange={(event) => setFormData((prev) => ({ ...prev, title: event.target.value }))}
                            placeholder="Enter ticket title"
                        />
                    </div>
                    <div className="mb-3">
                        <Form.Label>Details</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={6}
                            value={formData.detail}
                            onChange={(event) => setFormData((prev) => ({ ...prev, detail: event.target.value }))}
                            placeholder="Describe the issue"
                        />
                    </div>
                    <div className="mb-2">
                        <Form.Label>Attachments</Form.Label>
                        <Form.Control
                            type="file"
                            multiple
                            onChange={(event) => setFiles(Array.from(event.target.files || []))}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" variant="light" onClick={onHide} disabled={submitting}>
                        Cancel
                    </Button>
                    <Button type="submit" variant="primary" disabled={submitting}>
                        {submitting ? <Spinner size="sm" animation="border" className="me-2" /> : null}
                        Submit Ticket
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default SupportTicketCreateModal;